import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { LanguageStore } from '../../../shared/services/language.store';
import { ACS_CONTACT_LINK_EN, ACS_CONTACT_LINK_FR } from '../../../shared/helpers/constants';

@Component({
  selector: 'acs-product-option-section',
  imports: [MatIcon, TranslatePipe, ReactiveFormsModule],
  templateUrl: './product-option-section.component.html',
  styleUrl: `./product-option-section.component.scss`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductOptionSectionComponent {
  @Input({ required: true }) fc!: FormControl;
  @Input({ required: true }) authorizedCfe!: boolean;

  #langageStore: LanguageStore = inject(LanguageStore);

  get contactLink() {
    return this.#langageStore.currentLanguageCode() === 'fr'
      ? ACS_CONTACT_LINK_FR
      : ACS_CONTACT_LINK_EN;
  }
}
